import React, { ReactElement } from 'react';
import { Fail as FailComponent } from 'b2b-components/theme/components/Fail';
import { config } from 'b2b-apps/shop/config';
import { useTranslate } from 'b2b-apps/shop/i18n/hooks';
import { WrappedComponentProps as Props, WrappedComponentType as ComponentType } from './';

const Fail: ComponentType = ({
  error,
  ...props
}: Props): ReactElement => {
  const t = useTranslate();

  const isReportingErrors = config.showsErrors;

  return (
    <FailComponent
      message={
        (isReportingErrors && error && error.message)
        || t('Connection error occurred')
      }
      {...props}
    />
  );
};

export { Fail };
